import React, { Component } from 'react';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import { Editor } from 'primereact/editor';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class ViewPrivacyPolicyComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowIndex: null,
            isEditable: false,
            settingName: '',
            settingValue: '',
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e) => {
        // this.setState(prevState => ({
        //     emailSettingData:
        //         { ...prevState.emailSettingData,   
        //             EmailBody : e.htmlValue  }
        // }))
        this.setState({
            settingValue: e.htmlValue
        })
    }
    componentWillReceiveProps(nextProps) {
        const { t } = this.props;
        console.log("next", nextProps);
        if (nextProps.getPrivacyPolicyDetails.Message != this.props.getPrivacyPolicyDetails.Message) {
            if (nextProps.getPrivacyPolicyDetails.statusCode == 200) {
                swal(nextProps.getPrivacyPolicyDetails.Message, {
                    icon: "success",
                });
                this.setState({
                    rowIndex: null,
                    isEditable: false,
                    settingName: '',
                    settingValue: ''
                })
                this.props.getAllTermsData();
            }
        }
    }

    edit = (data) => {
        console.log("item", data);
        this.setState({
            rowIndex: data.index,
            isEditable: true,
            settingName: data.SettingName,
            settingValue: data.SettingValue
        })
    }
    cancel = () => {
        this.setState({
            rowIndex: null,
            isEditable: false,
            settingName: '',
            settingValue: ''
        })
    }
    save = () => {
        const { t } = this.props;
        if (this.state.settingValue.length) {
            // if(this.state.settingName == "AcceptTermsOfUse"){
            //     this.props.updateAcceptTermsOfUseFunc(this.state.settingValue);
            // }
            // else if(this.state.settingName == "TermsOfUse"){
            //     this.props.updateTermsOfUseDetails(this.state.settingValue);
            // }
            // else if(this.state.settingName == "TermsOfUseHeader"){
            //     this.props.updateTermsOfUseHeaderFunc(this.state.settingValue);
            // }
            // else if(this.state.settingName == "TermsOfUseSubHeader"){
            //     this.props.updateTermsOfUseSubHeaderFunc(this.state.settingValue);
            // }
            this.props.updatePrivacyPolicyFunc(this.state.settingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value')}`)
        }
    }
    render() {
        const { t } = this.props;
        return (
            <div className="container">
                <div className="progressbar-heading grids-heading">
                    {/* <h2>{t('Menu.Privacy Policy Setting')}</h2> */}
                    <br></br>
                    <br></br>

                    <h2>Privacy Policy</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className="setting-data">
                        {
                            (this.props.getPrivacyPolicyDetails && this.props.getPrivacyPolicyDetails.updatedValue.length) ?
                                this.props.getPrivacyPolicyDetails.updatedValue.map((item, index) =>
                                <div dangerouslySetInnerHTML={{ __html: item.SettingValue }}></div>
                                    // <div key={index} id={index} className="row contact-data">
                                    //     <div className="col-md-3">
                                    //         <div className="displaynone">{item.index = index}</div>
                                    //         <p className="displaynone">{item.isEdit = false}</p>
                                    //         <p>{item.DisplayName}</p>
                                    //     </div>
                                    //     <div className="col-md-6">
                                    //         {(this.state.rowIndex == item.index) ?
                                    //             // <textarea 
                                    //             // rows="4"
                                    //             // name= {'SettingValue'} 
                                    //             // value={this.state.settingValue}
                                    //             // onChange={this.handleChange} 
                                    //             // ></textarea>
                                    //             <Editor style={{ height: '200px' }} className="editor-email"
                                    //                 value={this.state.settingValue}
                                    //                 onTextChange={(e) => this.handleChange(e)} />
                                    //             :
                                    //             <p dangerouslySetInnerHTML={{ __html: item.SettingValue }}></p>
                                    //             // <p>{item.SettingValue}</p>
                                    //         }
                                    //     </div>
                                    //     <div className="col-md-3">
                                    //         {
                                    //             this.state.rowIndex == item.index ?
                                    //                 <div>
                                    //                     <button type="button" className="btn btn-primary mar-right-15"
                                    //                         onClick={this.save}>{t('Alarm Setting.Save')}</button>
                                    //                     <button type="button" className="btn btn-primary"
                                    //                         onClick={this.cancel}>{t('Alarm Setting.Cancel')}</button>
                                    //                 </div> :
                                    //                 <button type="button" onClick={this.edit.bind(this, item)}
                                    //                     className={this.state.isEditable == item.isEdit ? 'btn btn-primary' : 'btn btn-primary not-show-btn'}
                                    //                 >{t('Alarm Setting.Edit')}</button>
                                    //         }
                                    //     </div>
                                    // </div>
                                )
                                : <p>{t('First_Responder.No records found')}</p>}
                    </div>
                </div>
            </div>
        );
    }
}

export default withNamespaces()(ViewPrivacyPolicyComponent);